export const StaticConst = {
  MAX_ATTACHMENTS_WIDTH: 10000,
  MAX_ATTACHMENTS_HEIGHT: 10000,
  MAX_ATTACHMENTS_NUMBER: 2,
  MAX_LETTER_TEXT_COUNT: 5000,
  ALLOWED_FORMATS: ["image/png", "image/jpg", "image/jpeg"],
  MAX_FILE_SIZE_MB: 10,
  EAttachedFileType: {
    ORDINARY: "ORDINARY",
    ADMIN: "ADMIN",
    VIEW_ATTACH: "VIEW_ATTACH",
  },
};
